export default __webpack_public_path__ + "static/front--24-9e4e503a1758bae21e245cb93df9dafc.webp";